import {
  APPLY_ON_FIXED_PER_PERSON,
  APPLY_ON_ESTIMATED_PER_PERSON,
  APPLY_ON_FIXED_PER_HOUR,
  APPLY_ON_ESTIMATED_PER_HOUR,
  APPLY_ON_FIXED_PER_DAY,
  APPLY_ON_ESTIMATED_PER_DAY,
  APPLY_ON_ESTIMATED
} from '../../constants/costs';

export const getUnit = applyOn => {
  if (
    applyOn === APPLY_ON_FIXED_PER_PERSON ||
    applyOn === APPLY_ON_ESTIMATED_PER_PERSON
  ) {
    return 'person';
  }
  if (
    applyOn === APPLY_ON_FIXED_PER_HOUR ||
    applyOn === APPLY_ON_ESTIMATED_PER_HOUR
  ) {
    return 'hour';
  }
  if (
    applyOn === APPLY_ON_FIXED_PER_DAY ||
    applyOn === APPLY_ON_ESTIMATED_PER_DAY
  ) {
    return 'day';
  }
  return null;
};

export const isEstimatedCost = applyOn => {
  return (
    applyOn === APPLY_ON_ESTIMATED ||
    applyOn === APPLY_ON_ESTIMATED_PER_HOUR ||
    applyOn === APPLY_ON_ESTIMATED_PER_DAY ||
    applyOn === APPLY_ON_ESTIMATED_PER_PERSON
  );
};
